// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__S4KzM","col":"footer_col__bjlnP"};